import { render, staticRenderFns } from "./Dfes.vue?vue&type=template&id=31ecbb96&scoped=true&"
import script from "./Dfes.vue?vue&type=script&lang=js&"
export * from "./Dfes.vue?vue&type=script&lang=js&"
import style0 from "./Dfes.vue?vue&type=style&index=0&id=31ecbb96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ecbb96",
  null
  
)

export default component.exports